import { HumanProfileResult } from './human-profile.models';

function key(value: string): string {
  return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
}

const laikoAliases = new Set([
  'laiko', 'laiko 2', 'de laiko la lys', 'la lys laiko', 'laiko de la lys',
]);

export function isKnownLaikoAlias(name: string): boolean {
  return laikoAliases.has(key(name));
}

/** Groups only explicitly reviewed spelling variants; original database rows remain intact. */
export function collapseKnownDogDuplicates(results: HumanProfileResult[]): HumanProfileResult[] {
  const laikoDogs = results.map(result => result.team?.dog)
    .filter(dog => dog && isKnownLaikoAlias(dog.name));
  if (laikoDogs.length < 2) return results;

  const counts = new Map<string, number>();
  laikoDogs.forEach(dog => counts.set(dog!.id, (counts.get(dog!.id) ?? 0) + 1));
  const canonical = [...laikoDogs].sort((a, b) => {
    const exactA = a!.name === 'Laïko' ? 1 : 0;
    const exactB = b!.name === 'Laïko' ? 1 : 0;
    return exactB - exactA || (counts.get(b!.id) ?? 0) - (counts.get(a!.id) ?? 0);
  })[0]!;
  const dog = { ...canonical, name: 'Laïko', breed: 'Husky sibérien' };

  return results.map(result => {
    if (!result.team?.dog || !isKnownLaikoAlias(result.team.dog.name)) return result;
    return { ...result, team: { ...result.team, dogId: dog.id, dog } };
  });
}
